/**
 * Created by Ning Jiang on 10/19/2018.
 */

import {IScreenConfig, ScreenController} from "@nolimitcity/slot-game/bin/core/screen/ScreenController";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {TombstoneGameMode} from "../../gamemode/TombstoneGameMode";
import {TombstoneParsedGameData} from "../../server/data/TombstoneParsedGameData";
import {TombstoneSoundConfig} from "../../TombstoneSoundConfig";
import {TombstoneFreespinOutroView} from "../freespinoutro/TombstoneFreespinOutroView";
import {TombstoneGameModuleConfig} from "../../TombstoneGameModuleConfig";
import {TombstoneNoMercy} from "../../TombstoneNoMercy";

export class TombstoneSuperFreespinOutroController extends ScreenController {

    constructor(config:IScreenConfig) {
        super("SuperFreespinOutro", config);
        (<TombstoneFreespinOutroView>this._view).getPlaySoundCallback(() => this.playMainSound());
    }

    protected calculateIsTriggered(data: TombstoneParsedGameData): boolean {
        return !data.brokeTheBank && (data.mode === TombstoneGameMode.SUPER_FREESPIN && data.freespinsLeft === 0);
    }

    protected show():boolean {
        super.show();
        SlotGame.keypad.setZeroBetSpinCounter(-1);
        return true;
    }

    private playMainSound():void {
        SlotGame.sound.playAmbience(TombstoneSoundConfig.instance.MAIN_GAME_AMBIANCE);
        SlotGame.sound.fadeAmbience(0, 0);
        SlotGame.sound.fadeAmbience(1, 5000);

        // #277
        if (!(SlotGame.api.gameClientConfiguration.belowStakeWinRestriction && TombstoneGameModuleConfig.gameData.isWinBelowStake())) {
            SlotGame.sound.playEffect(this._serverData!.totalWin > 0 ? TombstoneSoundConfig.instance.BOUNTY_OUTRO : TombstoneSoundConfig.instance.BOUNTY_NOWIN_OUTRO);
        }
    }
    protected showKeypad() {
        SlotGame.keypad.show();
        if (!(SlotGame.api.gameClientConfiguration.belowStakeWinRestriction && TombstoneGameModuleConfig.gameData.isWinBelowStake())) {
            TombstoneNoMercy.keypad.setWin(TombstoneGameModuleConfig.gameData!.accumulatedRoundWin, true, TombstoneGameModuleConfig.gameData.isWinBelowStake());
        }
    }

}